import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import RoomContent from './roomContent';
import BuildingContent from './buildingContent';

const ContentWrapper = ({
  content, selected, texts, toggleRoomInfo, tabsExist,
}) => {
  if (!content) {
    return false;
  }
  let Content;
  switch (content.__typename) { // eslint-disable-line no-underscore-dangle
    case 'RoomConceptsTextSectionEntryV2':
      Content = RoomContent;
      break;
    case 'PartsTextSectionEntryV2':
      Content = BuildingContent;
      break;
    default:
      Content = undefined;
  }

  if (!Content) {
    return false;
  }

  return (
    <div
      key={uniqid('content-wrapper-')}
      style={{
        display: selected ? 'block' : 'none',
      }}
    >
      <Content
        content={content}
        texts={texts}
        toggleRoomInfo={toggleRoomInfo}
        tabsExist={tabsExist}
      />
    </div>
  );
};

ContentWrapper.propTypes = {
  content: PropTypes.shape({
    heading: PropTypes.string,
    intro: PropTypes.string,
    __typename: PropTypes.string,
    roomConcepts: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  texts: PropTypes.shape({}).isRequired,
  toggleRoomInfo: PropTypes.func.isRequired,
  tabsExist: PropTypes.bool.isRequired,
};

export default ContentWrapper;
